'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = 'src/panel-white.js';
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _glamorous = require('glamorous');
var _glamorous2 = _interopRequireDefault(_glamorous);
var _themes = require('@marmalade/themes');
var _panel = require('./panel');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
var _componentThemes$pane = _themes.componentThemes.panel,
  panelStyle = _componentThemes$pane.panelStyle,
  panelShadowStyle = _componentThemes$pane.panelShadowStyle,
  panelTheme = _componentThemes$pane.panelTheme,
  panelVariants = _componentThemes$pane.panelVariants;
var panelWhiteStyles = function panelWhiteStyles(props) {
  var theme = panelTheme(props.theme);
  return Object.assign({}, (0, _panel.panelStyles)(props), {
    borderWidth: theme[panelStyle('borderWidth', panelVariants.white)],
    position: 'relative',
    backgroundColor: theme[panelStyle('backgroundColor', panelVariants.white)]
  });
};
var panelShadowStyles = function panelShadowStyles(props) {
  var theme = panelTheme(props.theme);
  return {
    position: 'absolute',
    top: '100%',
    left: '2%',
    right: '2%',
    height: '5px',
    backgroundColor: theme[panelShadowStyle('backgroundColor')],
    borderBottomLeftRadius: theme[panelStyle('borderRadius')],
    borderBottomRightRadius: theme[panelStyle('borderRadius')]
  };
};
PanelWhite.propTypes = {
  children: _propTypes.node,
  condensed: _propTypes.bool
};
PanelWhite.defaultProps = {
  children: null,
  condensed: false
};
var Panel = (0, _glamorous2.default)('div')(panelWhiteStyles);
var Shadow = (0, _glamorous2.default)('div')(panelShadowStyles);
function PanelWhite(props) {
  var children = props.children,
    rest = _objectWithoutProperties(props, ['children']);
  return _react2.default.createElement(Panel, Object.assign({}, rest, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 49
    },
    __self: this
  }), children, _react2.default.createElement(Shadow, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 51
    },
    __self: this
  }));
}
exports.default = PanelWhite;